import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";

import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSSelectField from "../../../Components/Select/WSSelect";
import { useForm } from "react-hook-form";
import config from "../../../Config/clientConfig.json";
import WSDateField from "../../../Components/DateField/WSDateField";

export const TranserTable: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { register, control } = useForm();


  const columns: IColumns[] = [
    {
      header: "Table#",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "KOT#",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Owner",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Voucher#",
      fieldName: "address",
      tooltip: true,
    },
   
  ];

  const handleClick = (path: string) => {
    navigate(path);
  };

  return (
    <Grid container direction="column" sx={{ minHeight: "100vh" }}>
      {/* Header Section */}
      <Grid item>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          {/* Title on the left */}
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "green" }}>
          Take Table Ownership
          </Typography>
          <Grid sx={{ display: "flex"}}>
           
            <IconButton>
              <WSIcons.CloseIcon
                sx={{ backgroundColor: "red", color: "white" }}
                onClick={() => handleClick("/")}
              />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Grid item sx={{ flex: 1 }}>
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Grid>

      <Grid
        bgcolor="#333"
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        <Grid display="flex" alignItems={"center"} gap={10}>
          <Typography>Transfer To</Typography>
          <WSSelectField
                    rules={{ required: true }}
                    {...register("transferto")}
                    id="transferto"
                    control={control}
                    defaultValue={"0"}
                    label=""
                    name="transferto"
                  />
          <Button
            variant="contained"
            color="success"
          >
            Take
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
